import React from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Navbar from "./Navbar"
import Footer from "./Footer"
import Home from "./pages/Home"
import Works from "./pages/Works"
import WorkDetail from "./pages/WorkDetail"
import Services from "./pages/Services"
import About from "./pages/About"
import Journal from "./pages/Journal"
import Contact from "./pages/Contact"
import NotFound from "./pages/NotFound"
import ScrollToTop from "./ui/ScrollToTop"
import PageLoader from "./ui/PageLoader"

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageLoader />
      <div className="min-h-screen bg-stone-950 text-stone-100">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/works" element={<Works />} />
          <Route path="/works/:slug" element={<WorkDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  )
}
